import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const FollowUpTypeAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.followUpTypeAccess
        ? setValues((j) => ({
            ...j,
            followUpType: {
              create: true,
              edit: true,
              delete: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            followUpType: {
              create: false,
              edit: false,
              delete: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.followUpTypeAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      followUpType: { ...j.followUpType, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.followUpTypeAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.followUpType?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.followUpType?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.followUpType?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default FollowUpTypeAccess;
